import { replace } from 'connected-react-router'
import { getPageLocation } from 'selectors'
import { createPath, getDefaultPathname, updateCompatibility } from './helpers'

export const resetFilters = () => (dispatch, getState) => {
  const location = getPageLocation(getState())
  const defaultPathname = getDefaultPathname(location)

  dispatch(replace(({
    ...location,
    pathname: defaultPathname
  })))
}

export const applyFilter = ({ navigationState, ...locationProps }) => (dispatch, getState) => {
  const { pathname, search } = getPageLocation(getState())
  let newLocation = locationProps

  if (navigationState) {
    const { pathname: newPathname, search: newSearch } = createPath(navigationState, pathname)

    newLocation = {
      ...newLocation,
      pathname: newPathname,
      search: newSearch
    }
  }

  dispatch(replace({
    pathname,
    search,
    ...newLocation
  }))
}

export const updateQuery = event => (dispatch, getState) => {
  const { target: { value }} = event
  const { search, ...location } = getPageLocation(getState())

  dispatch(replace({
    ...location,
    search: updateCompatibility(search, value)
  }))
}
